<form [formGroup]="filterFormGroup" id="buildForm">
    <p-floatLabel variant="on">
        <p-multiSelect
            styleClass="w-30rem"
            maxSelectedLabels="1"
            appendTo="body"
            [options]="contracts"
            [filter]="true"
            formControlName="Contracts"
            selectedItemsLabel="{0} Contract(s) selected."
        >
        </p-multiSelect>
        <label for="float-dd">Select Contract(s)</label>
    </p-floatLabel>
</form>
